import React from "react";
import { useForm } from "../../../provider/Form/FormProvider";
import { Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import ValidatorSelectField from "../../FormFields/ValidatorSelectField";
import { isRequired, maxStringLength, minStringLength } from "../../../services/validationRules";
import MenuItem from "@mui/material/MenuItem";
import ValidatorTextField from "../../FormFields/ValidatorTextField";
import { AbstractCase } from "../../../types/Entities/AbstractCase";
import MessageFormEditor from "./MessageFormEditor";
import Button from "@mui/material/Button";
import { Link } from "react-router";
import IncompleteCaseWarning from "../MessageCenter/IncompleteCaseWarning";

type MessageFormStepInnerProps = {
  product: AbstractCase;
  isConversationAnswer: boolean;
};

export default function MessageFormStepInner({
  product,
  isConversationAnswer,
}: MessageFormStepInnerProps) {
  const { handleSubmit } = useForm();

  const legalQuestionLabel = product.responsibleLawyer
    ? `Rechtliche Frage an ${product.responsibleLawyer.gender === "male" ? "meinen Anwalt" : "meine Anwältin"}`
    : "Rechtliche Frage";

  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <Grid size={12}>
          <Typography variant={"h4"} sx={{ textAlign: "center" }}>
            Nachricht verfassen
          </Typography>
        </Grid>
        <IncompleteCaseWarning product={product} sx={{ marginLeft: "1rem" }} />
        {!isConversationAnswer && (
          <Grid size={12}>
            <ValidatorSelectField
              name={"type"}
              label={"Nachrichtenkategorie"}
              validators={[
                {
                  validator: isRequired,
                  message: "Bitte wählen Sie aus, welche Art von Nachricht Sie schreiben möchten.",
                },
              ]}
              MenuProps={{
                slotProps: {
                  list: {
                    sx: {
                      ".MuiMenuItem-root": {
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                      },
                    },
                  },
                },
              }}
            >
              {product.isCustomerDataCompleted && <MenuItem value={"submitCaseInfo"}>Weitere Infos/ Neuigkeiten zu meinem Fall mitteilen</MenuItem>}
              {product.isCustomerDataCompleted && <MenuItem value={"questionNextSteps"}>Rückfrage zum weiteren Vorgehen</MenuItem>}
              {product.isCustomerDataCompleted && <MenuItem value={"legalQuestion"}>{legalQuestionLabel}</MenuItem>}
              <MenuItem value={"technicalQuestion"}>Frage zur Servicewelt</MenuItem>
              {product.isCustomerDataCompleted && <MenuItem value={"other"}>Allgemeine Nachricht</MenuItem>}
            </ValidatorSelectField>
          </Grid>
        )}
        {!isConversationAnswer && (
          <Grid size={12}>
            <ValidatorTextField
              name={"subject"}
              label={"Nachrichtenbetreff"}
              validators={[
                {
                  validator: isRequired,
                  message: "Bitte geben Sie Ihrer Nachricht einen sprechenden Betreff, der den Inhalt kurz zusammenfasst.",
                },
                {
                  validator: minStringLength,
                  params: [5],
                  message: "Bitte geben Sie mindestens 5 Zeichen ein",
                },
                {
                  validator: maxStringLength,
                  params: [80],
                  message: "Bitte geben Sie maximal 80 Zeichen ein",
                },
              ]}
            />
          </Grid>
        )}

        <MessageFormEditor />

        <Grid
          size={{
            xs: 12,
            md: 6,
          }}
        >
          <Button fullWidth component={Link} to={"/servicewelt/nachrichten"}>
            Zurück
          </Button>
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 6,
          }}
        >
          <Button fullWidth variant={"contained"} type={"submit"}>
            Weiter
          </Button>
        </Grid>
      </Grid>
    </form>
  );
}
